<template>
  <div>
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <!-- Tabs bên trái -->
            <b-row class="align-items-center mb-2">
              <b-col md="6" class="mb-1 mb-md-0">
                <div class="tab-switch">
                  <button
                    type="button"
                    class="tab-btn"
                    :class="{ active: activeTab === 0 }"
                    @click="activeTab = 0; onTabChange(0)"
                  >
                    <feather-icon icon="LayersIcon" size="14" class="mr-50" />
                    Loại khoản thu
                  </button>
                  <button
                    type="button"
                    class="tab-btn"
                    :class="{ active: activeTab === 1 }"
                    @click="activeTab = 1; onTabChange(1)"
                  >
                    <feather-icon icon="DollarSignIcon" size="14" class="mr-50" />
                    Khoản thu
                  </button>
                  <button
                    type="button"
                    class="tab-btn"
                    :class="{ active: activeTab === 2 }"
                    @click="activeTab = 2; onTabChange(2)"
                  >
                    <feather-icon icon="FileTextIcon" size="14" class="mr-50" />
                    Kế hoạch thu
                  </button>
                  <button
                    type="button"
                    class="tab-btn"
                    :class="{ active: activeTab === 3 }"
                    @click="activeTab = 3; onTabChange(3)"
                  >
                    <feather-icon icon="CalendarIcon" size="14" class="mr-50" />
                    Dự kiến thu
                  </button>
                </div>
              </b-col>
            </b-row>

            <!-- Nội dung tab -->
            <b-tabs v-model="activeTab" class="content-tabs my-tabs" @input="onTabChange">
              <!-- Tab 1: Loại khoản thu -->
              <b-tab key="revenue-type">
                <b-row>
                  <b-col cols="12">
                    <div class="text-right mb-2">
                      <b-button
                        v-if="creatableRevenueType"
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        v-b-modal.revenueTypeSaveModal
                        variant="success"
                        size="sm"
                        @click="onCreateRevenueType"
                      >
                        <span class="text-nowrap text-right">
                          <feather-icon icon="PlusIcon" /> Thêm loại khoản thu
                        </span>
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="d-flex align-items-center mb-1 mt-0">
                      <span class="text-nowrap"> Hiển thị {{ filterRevenueType.itemsPerPage * (filterRevenueType.currentPage-1) +1 }}
                        đến {{ (filterRevenueType.itemsPerPage * (filterRevenueType.currentPage) >= totalRowsRevenueType)? totalRowsRevenueType : filterRevenueType.itemsPerPage * (filterRevenueType.currentPage) }} &nbsp; của {{ totalRowsRevenueType }} bản ghi
                      </span>
                    </div>
                    <vue-good-table
                      mode="remote"
                      class="my-table"
                      style-class="vgt-table striped bordered research-table"
                      row-style-class="vgt-row"
                      :columns="columnsRevenueType"
                      :rows="revenueTypes"
                      :pagination-options="paginationOptions"
                      :total-rows="totalRowsRevenueType"
                      line-numbers
                      @on-page-change="onPageChangeRevenueType"
                      @on-sort-change="onSortChangeRevenueType"
                      @on-column-filter="onColumnFilterRevenueType"
                      @on-per-page-change="onPerPageChangeRevenueType"
                    >
                      <div
                        slot="emptystate"
                        style="text-align: center; font-weight: bold"
                      >
                        Không có bản ghi nào !
                      </div>
                      <template
                        slot="table-row"
                        slot-scope="props"
                      >
                        <span v-if="props.column.field === 'stt'">
                          {{ props.row.originalIndex + 1 }}
                        </span>
                        <span v-if="props.column.field === 'status'">
                          {{ props.row.status == 1 ? 'Đang hoạt động' : 'Không hoạt động' }}
                        </span>
                        <span v-else-if="props.column.field === 'action'">
                          <b-button
                            v-if="updatableRevenueType"
                            v-b-modal.revenueTypeSaveModal
                            variant="primary"
                            class="btn-icon"
                            size="sm"
                            @click="onEditRevenueType(props.row)"
                          >
                            <feather-icon icon="Edit2Icon" />
                          </b-button>
                          <b-button
                            v-if="deletableRevenueType"
                            variant="danger"
                            class="btn-icon"
                            style="margin-left: 6px"
                            size="sm"
                            @click="onDeleteRevenueType(props.row)"
                          >
                            <feather-icon icon="TrashIcon" />
                          </b-button>
                        </span>
                        <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                      </template>
                      <template
                        slot="pagination-bottom"
                        slot-scope="props"
                      >
                        <div class="d-flex justify-content-between flex-wrap">
                          <div class="d-flex align-items-center mb-0 mt-1">
                            <span class="text-nowrap"> Hiển thị {{ filterRevenueType.itemsPerPage * (filterRevenueType.currentPage-1) +1 }}
                              đến {{ (filterRevenueType.itemsPerPage * (filterRevenueType.currentPage) >= totalRowsRevenueType)? totalRowsRevenueType : filterRevenueType.itemsPerPage * (filterRevenueType.currentPage) }} &nbsp; của {{ totalRowsRevenueType }} bản ghi
                            </span>
                          </div>
                          <div class="d-flex align-items-center mb-0 mt-1">
                            <span class="text-nowrap"> Hiển thị </span>
                            <b-form-select
                              v-model="filterRevenueType.itemsPerPage"
                              :options="itemsPerPageOptions"
                              class="mx-1"
                              @input="(value) => props.perPageChanged({ currentPerPage: value })"
                            />
                            <span class="text-nowrap"> bản ghi/trang</span>
                          </div>
                          <div>
                            <b-pagination
                              :value="1"
                              :total-rows="totalRowsRevenueType"
                              :per-page="filterRevenueType.itemsPerPage"
                              class="mt-1 mb-0"
                              @input="(value) => props.pageChanged({ currentPage: value })"
                            />
                          </div>
                        </div>
                      </template>
                    </vue-good-table>
                  </b-col>
                </b-row>
              </b-tab>

              <!-- Tab 2: Khoản thu -->
              <b-tab key="revenue">
                <b-row>
                  <b-col cols="12">
                    <div class="text-right mb-2">
                      <b-button
                        v-if="creatableRevenue"
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        v-b-modal.revenueSaveModal
                        variant="primary"
                        size="sm"
                        @click="onCreateRevenue"
                      >
                        <span class="text-nowrap text-right">
                          <feather-icon icon="PlusIcon" /> Thêm khoản thu
                        </span>
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="d-flex align-items-center mb-1 mt-0">
                      <span class="text-nowrap"> Hiển thị {{filterRevenue.itemsPerPage * (filterRevenue.currentPage-1) +1}}
                        đến {{(filterRevenue.itemsPerPage * (filterRevenue.currentPage) >= totalRowsRevenue)? totalRowsRevenue : filterRevenue.itemsPerPage * (filterRevenue.currentPage)}} &nbsp; của {{ totalRowsRevenue }} bản ghi
                      </span>
                    </div>
                    <vue-good-table
                      mode="remote"
                      class="my-table"
                      style-class="vgt-table striped bordered research-table"
                      row-style-class="vgt-row"
                      :columns="columnsRevenue"
                      :rows="revenues"
                      :pagination-options="paginationOptions"
                      :total-rows="totalRowsRevenue"
                      :line-numbers="true"
                      @on-page-change="onPageChangeRevenue"
                      @on-sort-change="onSortChangeRevenue"
                      @on-column-filter="onColumnFilterRevenue"
                      @on-per-page-change="onPerPageChangeRevenue"
                    >
                      <div
                        slot="emptystate"
                        style="text-align: center; font-weight: bold"
                      >
                        Không có bản ghi nào !
                      </div>
                      <template
                        slot="table-row"
                        slot-scope="props"
                      >
                        <span v-if="props.column.field === 'stt'">
                          {{ props.row.originalIndex + 1 }}
                        </span>
                        <span v-if="props.column.field === 'is_exemption'">
                          {{ props.row.is_exemption === 1 ? 'Có' : 'Không' }}
                        </span>
                        <span v-else-if="props.column.field === 'type_id'">
                          {{ getRevenueTypesName(props.row.type_id) }}
                        </span>
                        <span v-else-if="props.column.field === 'action'">
                          <b-button
                            v-if="updatableRevenue"
                            v-b-modal.revenueSaveModal
                            variant="primary"
                            class="btn-icon"
                            size="sm"
                            @click="onEditRevenue(props.row)"
                          >
                            <feather-icon icon="Edit2Icon" />
                          </b-button>
                          <b-button
                            v-if="deletableRevenue"
                            variant="danger"
                            class="btn-icon"
                            style="margin-left: 6px"
                            size="sm"
                            @click="onDeletetRevenue(props.row)"
                          >
                            <feather-icon icon="TrashIcon" />
                          </b-button>
                        </span>
                        <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                      </template>
                      <template
                        slot="pagination-bottom"
                        slot-scope="props"
                      >
                        <div class="d-flex justify-content-between flex-wrap">
                          <div class="d-flex align-items-center mb-0 mt-1">
                           <span class="text-nowrap"> Hiển thị {{filterRevenue.itemsPerPage * (filterRevenue.currentPage-1) +1}}
                            đến {{(filterRevenue.itemsPerPage * (filterRevenue.currentPage) >= totalRowsRevenue)? totalRowsRevenue : filterRevenue.itemsPerPage * (filterRevenue.currentPage)}} &nbsp; của {{ totalRowsRevenue }} bản ghi
                          </span>
                          </div>
                          <div class="d-flex align-items-center mb-0 mt-1">
                            <span class="text-nowrap"> Hiển thị </span>
                            <b-form-select
                                v-model="filterRevenue.itemsPerPage"
                                :options="itemsPerPageOptions"
                                class="mx-1"
                                @input="(value) => props.perPageChanged({ currentPerPage: value })"
                            />
                            <span class="text-nowrap"> bản ghi/trang</span>
                          </div>
                          <div>
                            <b-pagination
                                :value="1"
                                :total-rows="totalRowsRevenue"
                                :per-page="filterRevenue.itemsPerPage"
                                class="mt-1 mb-0"
                                @input="(value) => props.pageChanged({ currentPage: value })"
                            />
                          </div>
                        </div>
                      </template>
                    </vue-good-table>
                  </b-col>
                </b-row>
              </b-tab>

              <!-- Tab 3: Kế hoạch thu -->
              <b-tab key="revenue-plan">
                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label-cols="3"
                      label-cols-lg="3"
                      label="Loại hình đào tạo:"
                      label-for="trainingSystemsSelected"
                    >
                      <v-select
                        v-model="trainingSystemsSelected"
                        :options="trainingSystemsOptions"
                        :reduce="option => option.value"
                        @input="onChangeTrainingSystems"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                      label-cols="3"
                      label-cols-lg="3"
                      label="Khóa học:"
                      label-for="coursesSelected"
                    >
                      <v-select
                        v-model="coursesSelected"
                        :options="coursesOptions"
                        :reduce="option => option.value"
                        @input="onChangeCourses"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label-cols="3"
                      label-cols-lg="3"
                      label="Kỳ học:"
                      label-for="semestersSelect"
                    >
                      <v-select
                        v-model="semestersSelect"
                        :options="semestersOptions"
                        :reduce="option => option.value"
                        @input="onChangeSemesters"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                      label-cols="3"
                      label-cols-lg="3"
                      label="Ngành:"
                      label-for="majorsSelect"
                    >
                      <v-select
                        v-model="majorsSelect"
                        :options="majorsOptions"
                        :reduce="option => option.value"
                        @input="onChangeMajors"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="text-right mb-2">
                      <b-button
                        v-show="creatableRevenuePlan"
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        v-b-modal.revenuePlanSaveModal
                        variant="success"
                        size="sm"
                        style="margin-right: 5px"
                        @click="onCreateRevenuePlan"
                      >
                        <span class="text-nowrap text-right">Tạo mới</span>
                      </b-button>
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        size="sm"
                        style="margin-right: 5px"
                        @click="onSelectRevenuePlan"
                      >
                        <span class="text-nowrap text-right">Danh sách</span>
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col cols="12">
                    <div class="d-flex align-items-center mb-1 mt-0">
                      <span class="text-nowrap"> Hiển thị {{ filterRevenuePlan.itemsPerPage * (filterRevenuePlan.currentPage-1) +1 }}
                        đến {{ (filterRevenuePlan.itemsPerPage * (filterRevenuePlan.currentPage) >= totalRowsRevenuePlan)? totalRowsRevenuePlan : filterRevenuePlan.itemsPerPage * (filterRevenuePlan.currentPage) }} &nbsp; của {{ totalRowsRevenuePlan }} bản ghi
                      </span>
                    </div>
                    <vue-good-table
                      mode="remote"
                      class="my-table"
                      style-class="vgt-table striped bordered research-table"
                      row-style-class="vgt-row"
                      :columns="columnsRevenuePlan"
                      :rows="revenuePlans"
                      :pagination-options="paginationOptions"
                      :total-rows="totalRowsRevenuePlan"
                      :line-numbers = "true"
                      @on-page-change="onPageChangeRevenuePlan"
                      @on-sort-change="onSortChangeRevenuePlan"
                      @on-column-filter="onColumnFilterRevenuePlan"
                      @on-per-page-change="onPerPageChangeRevenuePlan"
                    >
                      <div
                        slot="emptystate"
                        style="text-align: center; font-weight: bold"
                      >
                        Không có bản ghi nào !
                      </div>
                      <template
                        slot="table-row"
                        slot-scope="props"
                      >
                        <span v-if="props.column.field === 'stt'">
                          {{ props.row.originalIndex + 1 }}
                        </span>
                        <span v-else-if="props.column.field === 'is_exemption'">
                          {{ props.row.is_exemption === 1 ? 'Có' : 'Không' }}
                        </span>
                        <span v-else-if="props.column.field === 'price'">
                          {{ new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(props.row.price) }}
                        </span>
                        <span v-else-if="props.column.field === 'total'">
                          {{ new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(props.row.total) }}
                        </span>
                        <span v-else-if="props.column.field === 'action'">
                          <b-button
                            v-if="updatableRevenuePlan"
                            v-b-modal.revenuePlanSaveModal
                            variant="primary"
                            class="btn-icon"
                            size="sm"
                            @click="onEditRevenuePlan(props.row)"
                          >
                            <feather-icon icon="Edit2Icon" />
                          </b-button>
                          <b-button
                            v-if="deletableRevenuePlan"
                            variant="danger"
                            class="btn-icon"
                            style="margin-left: 6px"
                            size="sm"
                            @click="onDeleteRevenuePlan(props.row)"
                          >
                            <feather-icon icon="TrashIcon" />
                          </b-button>
                        </span>
                        <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                      </template>
                      <template
                        slot="pagination-bottom"
                        slot-scope="props"
                      >
                        <div class="d-flex justify-content-between flex-wrap">
                          <div class="d-flex align-items-center mb-0 mt-1">
                            <span class="text-nowrap"> Hiển thị {{ filterRevenuePlan.itemsPerPage * (filterRevenuePlan.currentPage-1) +1 }}
                              đến {{ (filterRevenuePlan.itemsPerPage * (filterRevenuePlan.currentPage) >= totalRowsRevenuePlan)? totalRowsRevenuePlan : filterRevenuePlan.itemsPerPage * (filterRevenuePlan.currentPage) }} &nbsp; của {{ totalRowsRevenuePlan }} bản ghi
                            </span>
                          </div>
                          <div class="d-flex align-items-center mb-0 mt-1">
                            <span class="text-nowrap"> Hiển thị </span>
                            <b-form-select
                              v-model="filterRevenuePlan.itemsPerPage"
                              :options="itemsPerPageOptions"
                              class="mx-1"
                              @input="(value) => props.perPageChanged({ currentPerPage: value })"
                            />
                            <span class="text-nowrap"> bản ghi/trang</span>
                          </div>
                          <div>
                            <b-pagination
                              :value="1"
                              :total-rows="totalRowsRevenuePlan"
                              :per-page="filterRevenuePlan.itemsPerPage"
                              class="mt-1 mb-0"
                              @input="(value) => props.pageChanged({ currentPage: value })"
                            />
                          </div>
                        </div>
                      </template>
                    </vue-good-table>
                  </b-col>
                </b-row>
              </b-tab>

              <!-- Tab 4: Dự kiến thu -->
              <b-tab key="revenue-schedule">
                <b-row>
                  <b-col
                    cols="12"
                    md="4"
                  >
                    <b-form-group
                      label-for="admissionRoundId"
                    >
                      <v-select
                        v-model="filter.admissionRoundId"
                        :options="admissionRounds"
                        :reduce="option => option.value"
                        placeholder="Đợt xét tuyển"
                        @input="readAdmissionForm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                    md="6"
                    lg="4"
                  >
                    <b-form-group
                      label-for="admissionFormId"
                    >
                      <v-select
                        id="admissionFormId"
                        v-model="filter.admissionFormId"
                        :options="dataListAdmissionForm"
                        :reduce="option => option.value"
                        placeholder="Phương thức xét tuyển"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                    lg="4"
                  >
                    <b-row>
                      <b-col
                        cols="12"
                        class="text-right"
                      >
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          size="sm"
                          class="mr-1"
                          @click="btnSearchClick()"
                        >
                          <feather-icon
                            icon="SearchIcon"
                            class="align-text-top"
                          />
                          Tìm kiếm
                        </b-button>
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          v-b-modal.saveModal
                          variant="success"
                          size="sm"
                          class=""
                          @click="onCreate"
                        >
                        <span class="text-nowrap text-right">
                          <feather-icon icon="PlusIcon" /> Thêm mới
                        </span>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="">
                  <b-col cols="12">
                    <vue-good-table
                      mode="remote"
                      class="my-table"
                      row-style-class="vgt-row"
                      style-class="vgt-table striped bordered"
                      :columns="columns"
                      :rows="admissionRevenueSchedule"
                      :pagination-options="paginationOptions"
                      :total-rows="totalRows"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                    >
                      <div
                        slot="emptystate"
                        style="text-align: center; font-weight: bold"
                      >
                        Không có bản ghi nào !
                      </div>
                      <template
                        slot="table-row"
                        slot-scope="props"
                      >
                      <span v-if="props.column.field === 'status'">
                        {{ getStatusName(props.row.status) }}
                      </span>
                        <span v-else-if="props.column.field === 'price'">
                          {{ new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(props.row.price) }}
                        </span>
                        <span
                          v-else-if="props.column.field === 'action'"
                          class="thead-group-action"
                        >
                        <b-button-group>
                          <b-button
                            v-if="updatable"
                            v-b-modal.saveModal
                            variant="primary"
                            class="btn-icon"
                            size="sm"
                            @click="onEdit(props.row)"
                          >
                            <feather-icon icon="Edit2Icon" />
                          </b-button>
                          <b-button
                            v-if="deletable"
                            variant="danger"
                            class="btn-icon"
                            size="sm"
                            @click="onDelete(props.row)"
                          >
                            <feather-icon icon="TrashIcon" />
                          </b-button>
                        </b-button-group>
                      </span>
                        <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                      </template>
                      <template
                        slot="pagination-bottom"
                        slot-scope="props"
                      >
                        <div class="d-flex justify-content-between flex-wrap">
                          <div class="d-flex align-items-center ml-1 mb-1 mt-1">
                          <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                            đến {{ filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                          </span>
                          </div>
                          <div class="d-flex align-items-center mb-1 mt-1">
                            <span class="text-nowrap"> Hiển thị </span>
                            <b-form-select
                              v-model="filter.itemsPerPage"
                              :options="itemsPerPageOptions"
                              class="mx-1"
                              @input="(value) => props.perPageChanged({ currentPerPage: value })"
                            />
                            <span class="text-nowrap"> bản ghi/trang</span>
                          </div>
                          <div>
                            <b-pagination
                              :value="1"
                              :total-rows="totalRows"
                              :per-page="filter.itemsPerPage"
                              class="mt-1 mb-0"
                              @input="(value) => props.pageChanged({ currentPage: value })"
                            />
                          </div>
                        </div>
                      </template>
                    </vue-good-table>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </div>
        </b-overlay>
      </b-card>

      <!-- Modals -->
      <b-modal
        ref="modal-save"
        id="modal-save"
        ok-only
        ok-title="Chấp nhận"
        centered
        size="lg"
        title="Thêm/Sửa dự kiến thu"
        :hide-footer=true
      >
        <RevenueScheduleSave @succeed="onSucceed" :revenueSchedule="currentAdmissionRevenueSchedule" />
      </b-modal>
    </b-container>

    <!-- Revenue Type Save Modal -->
    <RevenueTypeSave
      ref="revenuetypeSaveFormRef"
      :revenue-type="currentRevenueType"
      @succeed="onSucceedRevenueType"
    />

    <!-- Revenue Save Modal -->
    <revenueSave
      ref="revenueSaveFormRef"
      :revenue="currentRevenue"
      @succeed="onSucceedRevenue"
    />

    <!-- Revenue Plan Save Modal -->
    <revenuePlanSave
      ref="revenuePlansSaveFormRef"
      :revenue-plan="currentRevenuePlan"
      @succeed="onSucceedRevenuePlan"
    />
  </div>
</template>

<script>
import {
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BContainer,
  BFormGroup,
  BFormSelect,
  BOverlay,
  BPagination,
  BRow,
  BTabs,
  BTab,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { showSuccessToast, showErrorToast } from '@/utils/notification'
import '@core/scss/vue/libs/vue-good-table.scss'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import RevenueScheduleSave from '@/views/admission/revenue-schedule/RevenueScheduleSave'
import RevenueTypeSave from '@/views/admin/category/revenuetype/RevenueTypeSave.vue'
import revenueSave from '@/views/finance/revenue/RevenueSave.vue'
import revenuePlanSave from '@/views/finance/revenue-plan/RevenuePlanSave.vue'
import { getUser } from '@/auth/utils'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'

export default {
  name: 'Index',
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BButtonGroup,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    BFormGroup,
    VueGoodTable,
    vSelect,
    RevenueScheduleSave,
    RevenueTypeSave,
    revenueSave,
    revenuePlanSave,
    BTabs,
    BTab,
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      activeTab: 0,
      // Revenue Schedule (Tab 4)
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        organizationId: getUser().orgId,
        admissionRoundId: null,
        admissionFormId: null,
        sort: '',
      },
      currentAdmissionRevenueSchedule: {},
      // Revenue Type (Tab 1)
      filterRevenueType: {
        currentPage: 1,
        itemsPerPage: 10,
        code: '',
        name: '',
        status: '',
        sort: '',
      },
      currentRevenueType: undefined,
      // Revenue (Tab 2)
      filterRevenue: {
        organization_id: getUser().orgId,
        currentPage: 1,
        itemsPerPage: 10,
        code: '',
        name: '',
        revenue: null,
        status: '',
        sort: '',
      },
      currentRevenue: undefined,
      // Revenue Plan (Tab 3)
      trainingSystemsSelected: undefined,
      coursesSelected: undefined,
      semestersSelect: undefined,
      majorsSelect: null,
      filterRevenuePlan: {
        currentPage: 1,
        itemsPerPage: 10,
        name: null,
        organization_id: getUser().orgId,
        training_system_id: null,
        course_id: null,
        semester_id: null,
        major_id: null,
        sort: null,
      },
      currentRevenuePlan: {
        training_system_id: null,
        course_id: null,
        semester_id: null,
        major_id: null,
        revenue_id: null,
        price: null,
        total: null,
        start_at: null,
        end_at: null,
        course_semester_id: null,
        id: null,
      },
      paginationOptions: {
        enabled: true,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      // Revenue Type columns
      columnsRevenueType: [
        {
          label: 'Mã',
          field: 'code',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Tên loại khoản thu',
          field: 'name',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
          width: '40%',
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Trạng thái',
          field: 'status',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
            filterDropdownItems: [
              { value: 1, text: 'Hoạt động' },
              { value: 0, text: 'Không hoạt động' },
            ],
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Thứ tự',
          field: 'orderNo',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Thao tác',
          field: 'action',
          width: '100px',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
      // Revenue columns
      columnsRevenue: [
        {
          label: 'Tên khoản thu',
          field: 'name',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Loại khoản thu',
          field: 'type_id',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
            filterDropdownItems: [],
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Miễn giảm',
          field: 'is_exemption',
          filterOptions: {
            enabled: false,
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: '',
          field: 'action',
          width: '100px',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
      // Revenue Plan columns
      columnsRevenuePlan: [
        {
          label: 'Loại khoản thu',
          field: 'revenue_type_name',
          filterOptions: {
            enabled: false,
            trigger: 'enter',
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Tên khoản thu',
          field: 'revenue_name',
          filterOptions: {
            enabled: false,
            trigger: 'enter',
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Số tiền tín chỉ',
          field: 'price',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Số tiền khoản thu',
          field: 'total',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Bắt đầu',
          field: 'start_at',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Kết thúc',
          field: 'end_at',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Kỳ học',
          field: 'semester_name',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Ngành',
          field: 'major_name',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Miễn giảm',
          field: 'is_exemption',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: '',
          field: 'action',
          sortable: false,
          width: '100px',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      // Revenue Schedule
      totalRows: 'admissionRevenueSchedule/totalRows',
      statuses: 'admissionRound/statuses',
      admissionRevenuePlans: 'admissionRevenuePlan/admissionRevenuePlans',
      admissionRounds: 'admissionRound/admissionRoundsByOrganization',
      dataListAdmissionForm: 'admissionForm/admissionFormByAdmissionRoundId',
      admissionRevenueSchedule: 'admissionRevenueSchedule/admissionRevenueSchedule',
      // Revenue Type
      revenueTypes: 'revenuetype/revenueTypes',
      totalRowsRevenueType: 'revenuetype/totalRows',
      // Revenue
      revenues: 'revenue/revenues',
      totalRowsRevenue: 'revenue/totalRows',
      allRevenueTypes: 'revenue/allRevenueTypes',
      // Revenue Plan
      revenuePlans: 'revenuePlan/revenuePlans',
      totalRowsRevenuePlan: 'revenuePlan/totalRows',
      allTrainingSystems: 'revenuePlan/allTrainingSystems',
      allMajors: 'revenuePlan/allMajors',
      listCourses: 'revenuePlan/listCourses',
      listSemesters: 'revenuePlan/listSemesters',
    }),
    columns() {
      return [
        {
          label: 'STT',
          field: 'rowNum',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Phương thức xét tuyển',
          field: 'admissionFormName',
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Tên khoản thu',
          field: 'admissionRevenueName',
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Số tiền khoản thu',
          field: 'price',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Bắt đầu',
          field: 'startAt',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Kết thúc',
          field: 'endAt',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Trạng thái',
          field: 'status',
          filterOptions: {
            placeholder: 'Tất cả',
            enabled: true,
            trigger: 'enter',
            filterDropdownItems: this.statusFilterDropdownItems,
          },
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: '',
          field: 'action',
          width: '80px',
          sortable: false,
          tdClass: 'text-center',
        },
      ]
    },
    statusFilterDropdownItems() {
      return this.statuses.map(status => ({
        value: status.value,
        text: status.label
      }))
    },
    revenueTypesFilterDropdownItems() {
      return this.allRevenueTypes.map(item => ({ value: item.id, text: item.name }))
    },
    trainingSystemsOptions() {
      return this.allTrainingSystems.map(item => ({ value: item.id, label: item.name }))
    },
    coursesOptions() {
      return this.listCourses.map(item => ({ value: item.id, label: item.name }))
    },
    semestersOptions() {
      return this.listSemesters.map(item => ({ value: item.id, label: item.name }))
    },
    majorsOptions() {
      return this.allMajors.map(item => ({ value: item.id, label: item.name }))
    },
    // Permissions
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.ADMISSION_REVENUE)
    },
    updatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.ADMISSION_REVENUE)
    },
    deletable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.ADMISSION_REVENUE)
    },
    creatableRevenueType() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.REVENUETYPES)
    },
    updatableRevenueType() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.REVENUETYPES)
    },
    deletableRevenueType() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.REVENUETYPES)
    },
    creatableRevenue() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.REVENUE)
    },
    updatableRevenue() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.REVENUE)
    },
    deletableRevenue() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.REVENUE)
    },
    creatableRevenuePlan() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.REVENUE_PLAN)
    },
    updatableRevenuePlan() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.REVENUE_PLAN)
    },
    deletableRevenuePlan() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.REVENUE_PLAN)
    },
  },
  async created() {
    this.isLoading = true
    try {
      await Promise.all([
        this.getAdmissionRoundsByOrganization({ organizationId: getUser().orgId }),
        this.getRevenueTypes(this.filterRevenueType),
        this.beginRevenue(),
        this.beginRevenuePlan({ organization_id: getUser().orgId }),
      ])
      // Update revenue types filter dropdown
      this.columnsRevenue[1].filterDropdownItems = this.revenueTypesFilterDropdownItems
    } catch ( e ) {
      showErrorToast(this, e)
    } finally {
      this.isLoading = false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.hideTabTitles()
    })
  },
  methods: {
    ...mapActions({
      // Revenue Schedule
      readAdmissionFormByAdmissionRoundId: 'admissionForm/readAdmissionFormByAdmissionRoundId',
      getAdmissionRoundsByOrganization: 'admissionRound/readAdmissionRoundsByOrganization',
      readAdmissionRevenueSchedule: 'admissionRevenueSchedule/readAdmissionRevenueSchedule',
      deleteAdmissionRevenueSchedule: 'admissionRevenueSchedule/deleteAdmissionRevenueSchedule',
      // Revenue Type
      getRevenueTypes: 'revenuetype/getRevenueTypes',
      deleteRevenueType: 'revenuetype/deleteRevenueType',
      // Revenue
      beginRevenue: 'revenue/begin',
      getRevenues: 'revenue/getRevenues',
      deleteRevenue: 'revenue/deleteRevenue',
      // Revenue Plan
      beginRevenuePlan: 'revenuePlan/begin',
      getRevenuePlans: 'revenuePlan/getRevenuePlans',
      getCourses: 'revenuePlan/getCourses',
      getSemesters: 'revenuePlan/getSemesters',
      deleteRevenuePlan: 'revenuePlan/deleteRevenuePlan',
    }),
    hideTabTitles() {
      const myTabs = document.querySelector('.my-tabs')
      if (myTabs) {
        const navTabs = myTabs.querySelectorAll('.nav-tabs, .nav, ul.nav-tabs, ul.nav')
        navTabs.forEach(nav => {
          if (nav) {
            nav.style.display = 'none'
          }
        })
        const navItems = myTabs.querySelectorAll('.nav-item, .nav-link')
        navItems.forEach(item => {
          if (item) {
            item.style.display = 'none'
          }
        })
      }
    },
    onTabChange(tabIndex) {
      this.activeTab = tabIndex
      if (tabIndex === 0) {
        // Revenue Type tab
        this.getRevenueTypesFromStore()
      } else if (tabIndex === 1) {
        // Revenue tab
        this.getRevenuesFromStore()
      } else if (tabIndex === 2) {
        // Revenue Plan tab
        // Already loaded in created
      } else if (tabIndex === 3) {
        // Revenue Schedule tab
        // Already loaded in created
      }
    },
    // Revenue Schedule methods
    async readAdmissionForm(id) {
      await this.readAdmissionFormByAdmissionRoundId({ admissionRoundId: id })
    },
    async btnSearchClick() {
      this.isLoading = true
      try {
        await Promise.all([
          this.readAdmissionRevenueSchedule(this.filter),
        ])
      } catch ( e ) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    onCreate() {
      this.$bvModal.show('modal-save')
      this.currentAdmissionRevenueSchedule = null
    },
    onEdit(admissionRevenuePlan) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = admissionRevenuePlan
      this.$bvModal.show('modal-save')
      this.currentAdmissionRevenueSchedule = rest
    },
    onDelete(admissionRevenuePlan) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa kế hoạch thu của khoản thu <span class="text-danger">${admissionRevenuePlan.admissionRevenueName}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if ( result.value ) {
            this.isLoading = true
            try {
              const response = await this.deleteAdmissionRevenueSchedule(admissionRevenuePlan.id)
              if ( response ) {
                const {
                  isSuccessful,
                  message
                } = response
                if ( isSuccessful ) {
                  showSuccessToast(this, message)
                  try {
                    await this.readAdmissionRevenueSchedule(this.filter)
                  } catch ( e ) {
                    showErrorToast(this, e)
                  }
                } else {
                  showErrorToast(this, message)
                }
              }
            } catch ( e ) {
              showErrorToast(this, e)
            } finally {
              this.isLoading = false
            }
          }
        })
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getDataFromStore()
    },
    async getDataFromStore() {
      this.isLoading = true
      try {
        await this.readAdmissionRevenueSchedule(this.filter)
      } catch ( e ) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChange(param) {
      this.updateParams({
        currentPage: param.currentPage,
        itemsPerPage: param.currentPerPage
      })
      await this.getDataFromStore()
    },
    async onSortChange(param) {
      if ( param.length > 0 ) {
        const {
          field,
          type
        } = param[0]
        if ( field === 'name' ) this.updateParams({ sort: `1_${type}` })
        else if ( field === 'code' ) this.updateParams({ sort: `2_${type}` })
        else if ( field === 'orderNo' ) this.updateParams({ sort: `3_${type}` })
        else this.updateParams({ sort: `3_${type}` })
      }
      await this.getDataFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if ( Object.hasOwn(columnFilters, 'status') ) this.updateParams({ status: columnFilters.status })
      await this.getDataFromStore()
    },
    getStatusName(id) {
      return this.statuses.find(status => status.value === id).label
    },
    async onSucceed() {
      this.$bvModal.hide('modal-save')
      await this.getDataFromStore()
    },
    // Revenue Type methods
    onCreateRevenueType() {
      this.currentRevenueType = undefined
    },
    onEditRevenueType(revenuetype) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = revenuetype
      this.currentRevenueType = rest
    },
    onDeleteRevenueType(revenuetype) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa loại khoản thu <span class="text-danger">${revenuetype.name}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.deleteRevenueType(revenuetype.id)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                showSuccessToast(this, message)
                try {
                  await this.getRevenueTypes(this.filterRevenueType)
                } catch (e) {
                  showErrorToast(this, e)
                }
              } else {
                showErrorToast(this, message)
              }
            }
          } catch (e) {
            showErrorToast(this, e)
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    updateParamsRevenueType(newProps) {
      this.filterRevenueType = { ...this.filterRevenueType, ...newProps }
    },
    async onPageChangeRevenueType(param) {
      this.updateParamsRevenueType({ currentPage: param.currentPage })
      await this.getRevenueTypesFromStore()
    },
    async getRevenueTypesFromStore() {
      this.isLoading = true
      try {
        await this.getRevenueTypes(this.filterRevenueType)
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChangeRevenueType(param) {
      this.updateParamsRevenueType({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getRevenueTypesFromStore()
    },
    async onSortChangeRevenueType(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        if (field === 'name') this.updateParamsRevenueType({ sort: `1_${type}` })
        else if (field === 'code') this.updateParamsRevenueType({ sort: `2_${type}` })
        else this.updateParamsRevenueType({ sort: `3_${type}` })
      }
      await this.getRevenueTypesFromStore()
    },
    async onColumnFilterRevenueType(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'name')) this.updateParamsRevenueType({ name: columnFilters.name })
      if (Object.hasOwn(columnFilters, 'code')) this.updateParamsRevenueType({ code: columnFilters.code })
      if (Object.hasOwn(columnFilters, 'status')) this.updateParamsRevenueType({ status: columnFilters.status })
      await this.getRevenueTypesFromStore()
    },
    async onSucceedRevenueType() {
      await this.getRevenueTypesFromStore()
    },
    // Revenue methods
    onCreateRevenue() {
      this.currentRevenue = undefined
    },
    onEditRevenue(revenue) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = revenue
      this.currentRevenue = rest
    },
    onDeletetRevenue(revenue) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa khoản thu <span class="text-danger">${revenue.name}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.deleteRevenue(revenue.id)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                showSuccessToast(this, message)
                try {
                  await this.getRevenues(this.filterRevenue)
                } catch (e) {
                  showErrorToast(this, e)
                }
              } else {
                showErrorToast(this, message)
              }
            }
          } catch (e) {
            showErrorToast(this, e)
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    updateParamsRevenue(newProps) {
      this.filterRevenue = { ...this.filterRevenue, ...newProps }
    },
    async onPageChangeRevenue(param) {
      this.updateParamsRevenue({ currentPage: param.currentPage })
      await this.getRevenuesFromStore()
    },
    async getRevenuesFromStore() {
      this.isLoading = true
      try {
        await this.getRevenues(this.filterRevenue)
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChangeRevenue(param) {
      this.updateParamsRevenue({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getRevenuesFromStore()
    },
    async onSortChangeRevenue(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        if (field === 'name') this.updateParamsRevenue({ sort: `1_${type}` })
        else if (field === 'code') this.updateParamsRevenue({ sort: `2_${type}` })
        else this.updateParamsRevenue({ sort: `3_${type}` })
      }
      await this.getRevenuesFromStore()
    },
    async onColumnFilterRevenue(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'name')) this.updateParamsRevenue({ name: columnFilters.name })
      if (Object.hasOwn(columnFilters, 'code')) this.updateParamsRevenue({ code: columnFilters.code })
      if (Object.hasOwn(columnFilters, 'type_id')) this.updateParamsRevenue({ revenue: columnFilters.type_id })
      await this.getRevenuesFromStore()
    },
    async onSucceedRevenue() {
      await this.getRevenuesFromStore()
    },
    getRevenueTypesName(id) {
      const type = this.allRevenueTypes.find(item => item.id === id)
      return type ? type.name : '-'
    },
    // Revenue Plan methods
    onCreateRevenuePlan() {
      this.currentRevenuePlan = {
        training_system_id: null,
        courseId: null,
        semester_id: null,
        major_id: null,
        revenue_id: null,
        price: null,
        total: null,
        start_at: null,
        end_at: null,
        courseSemesterId: null,
        id: null,
      }
    },
    async onSelectRevenuePlan() {
      this.isLoading = true
      try {
        await this.getRevenuePlans(this.filterRevenuePlan)
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    onChangeTrainingSystems() {
      if (this.trainingSystemsSelected == null) {
        this.resetRevenuePlan()
        this.$store.commit('revenuePlan/SET_COURSES', { data: [] })
        this.$store.commit('revenuePlan/SET_SEMESTERS', { data: [] })
        this.coursesSelected = null
        this.semestersSelect = null
        this.currentRevenuePlan.course_semester_id = null
      } else {
        this.currentRevenuePlan.training_system_id = this.trainingSystemsSelected
        this.getCourses({
          training_system_id: this.trainingSystemsSelected,
        })
      }
      this.filterRevenuePlan.training_system_id = this.trainingSystemsSelected
    },
    onChangeCourses() {
      if (this.coursesSelected == null) {
        this.resetRevenuePlan()
        this.$store.commit('revenuePlan/SET_SEMESTERS', { data: [] })
        this.semestersSelect = null
        this.currentRevenuePlan.course_semester_id = null
      } else {
        this.currentRevenuePlan.course_id = this.coursesSelected
        this.filterRevenuePlan.course_id = this.coursesSelected
        this.getSemesters({
          courses_id: this.coursesSelected,
        })
      }
    },
    onChangeSemesters() {
      if (this.semestersSelect == null) {
        this.resetRevenuePlan()
        this.currentRevenuePlan.course_semester_id = null
      } else {
        this.currentRevenuePlan.semester_id = this.semestersSelect
        this.filterRevenuePlan.semester_id = this.semestersSelect
        const item = this.listSemesters.find(x => x.id === this.semestersSelect)
        this.currentRevenuePlan.course_semester_id = item.courses_semesters_id
      }
    },
    onChangeMajors() {
      if (this.majorsSelect == null) {
        this.currentRevenuePlan.major_id = null
        this.resetRevenuePlan()
      } else {
        this.currentRevenuePlan.major_id = this.majorsSelect
        this.filterRevenuePlan.major_id = this.majorsSelect
      }
    },
    resetRevenuePlan() {
      this.$store.commit('revenuePlan/SET_REVENUEPLANS', { total: 0, records: [] })
    },
    onEditRevenuePlan(revenuePlan) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = revenuePlan
      this.currentRevenuePlan = { ...this.currentRevenuePlan, ...rest }
    },
    onDeleteRevenuePlan(revenuePlan) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa kế hoạch thu <span class="text-danger">${revenuePlan.revenue_name}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.deleteRevenuePlan(revenuePlan.id)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                showSuccessToast(this, message)
                try {
                  await this.getRevenuePlans(this.filterRevenuePlan)
                } catch (e) {
                  showErrorToast(this, e)
                }
              } else {
                showErrorToast(this, message)
              }
            }
          } catch (e) {
            showErrorToast(this, e)
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    updateParamsRevenuePlan(newProps) {
      this.filterRevenuePlan = { ...this.filterRevenuePlan, ...newProps }
    },
    async onPageChangeRevenuePlan(param) {
      this.updateParamsRevenuePlan({ currentPage: param.currentPage })
      await this.getRevenuePlansFromStore()
    },
    async getRevenuePlansFromStore() {
      this.isLoading = true
      try {
        await this.getRevenuePlans(this.filterRevenuePlan)
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChangeRevenuePlan(param) {
      this.updateParamsRevenuePlan({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getRevenuePlansFromStore()
    },
    async onSortChangeRevenuePlan(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        if (field === 'name') this.updateParamsRevenuePlan({ sort: `1_${type}` })
      }
      await this.getRevenuePlansFromStore()
    },
    async onColumnFilterRevenuePlan(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'name')) this.updateParamsRevenuePlan({ name: columnFilters.name })
      await this.getRevenuePlansFromStore()
    },
    async onSucceedRevenuePlan() {
      await this.getRevenuePlansFromStore()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

/* Tab Switch Styles - giống Scheduler.vue */
.tab-switch {
  display: inline-flex;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  overflow: hidden;
  background: #f8f9fa;
}

.tab-btn {
  border: none;
  background: transparent;
  padding: 8px 16px;
  font-size: 0.9rem;
  color: #495057;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.tab-btn + .tab-btn {
  border-left: 1px solid #dee2e6;
}

.tab-btn.active {
  background: #1e90ff;
  color: #fff;
}

.tab-btn:hover:not(.active) {
  background: #e9ecef;
}

.tab-btn:focus {
  outline: none;
}

.mr-50 {
  margin-right: 0.5rem;
}

.my-tabs .nav-tabs,
.my-tabs .nav,
.my-tabs ul.nav-tabs,
.my-tabs ul.nav {
  display: none !important;
}

.my-tabs .nav-item,
.my-tabs .nav-link {
  display: none !important;
}

.my-tabs .tab-content {
  border: none !important;
  padding: 0 !important;
}

.my-tabs .nav-tabs:not(.show),
.my-tabs .nav:not(.show) {
  display: none !important;
}

.my-tabs .nav-tabs li,
.my-tabs .nav li {
  display: none !important;
}

div.my-tabs .nav-tabs,
div.my-tabs .nav,
div.my-tabs ul.nav-tabs,
div.my-tabs ul.nav,
div.my-tabs .nav-item,
div.my-tabs .nav-link {
  display: none !important;
}

.my-tabs .nav-tabs *,
.my-tabs .nav * {
  display: none !important;
}
</style>
